module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/45d38638d4092932841dbdbc6dbfe47e.png";